import { HTTP_METHOD, makeRequest } from '../utils/request';

/**
 * clinicIds may be a single id or an array of ids.
 * `.toString()` will convert a single ID as-is, an array of IDs into a comma-separated string.
 */
export const apiGetClinics = (clinicIds) =>
  makeRequest({
    method: HTTP_METHOD.GET,
    url: `${CONFIG.API_URL}/clinic/v2`,
    params: {
      ids: clinicIds.toString(),
      options: JSON.stringify({
        isInteractionRestricted: true,
      }),
    },
  });

export const apiGetServicesForSpecialty = (specialtyId) =>
  makeRequest({
    method: HTTP_METHOD.GET,
    url: `${CONFIG.API_URL}/service`,
    params: {
      specialty: specialtyId,
    },
  });

export const apiGetFeaturesForSpecialty = (specialtyId) =>
  makeRequest({
    method: HTTP_METHOD.GET,
    url: `${CONFIG.API_URL}/feature`,
    params: {
      specialty: specialtyId,
    },
  });

export const apiGetClinicPerformanceBadges = (clinicId) =>
  makeRequest({
    method: HTTP_METHOD.GET,
    url: `${CONFIG.API_URL}/clinic/analytics/badges/${clinicId}`,
  });
